<template>
  <div class="main" v-if="orShow">
    <img
      class="bg-img"
      src="../assets/img/makeAppointment/makenew.png"
      alt=""
    />
    <p class="tit">科技让城市管理更简单，让生活更美好！</p>
    <span class="des"
      >全域覆盖城市治理，为客户提供成熟的解决方案及产品应用</span
    >
    <div class="btn" @click="subscribe">预约产品演示</div>
    <MakeAppointForm />
  </div>
</template>

<script>
import MakeAppointForm from "./MakeAppointForm.vue";
export default {
  name: "MakeAppointment",
  components: { MakeAppointForm },
  data() {
    return {
      orShow: true,
    };
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      this.isShowFun(to.path);
    },
  },
  mounted() {
    this.isShowFun(this.$route.path);
  },
  methods: {
    // 判断是否显示当前模块
    isShowFun(path) {
      if (path == "/joins") {
        this.orShow = false;
      } else {
        this.orShow = true;
      }
    },
    // 预约演示按钮
    subscribe() {
      this.$store.commit("changeShowMakeAppoint", true);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  padding-top: 7px;
  height: 300px;
  width: 100%;
  background: #f5f8fe;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  .bg-img {
    width: 372px;
    height: 286px;
    position: absolute;
    top: 7px;
  }
  .tit {
    font-size: 28px;
    font-weight: 400;
    color: #222222;
    z-index: 1;
  }
  .des {
    margin-top: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #a1a1a1;
    z-index: 1;
  }
  .btn {
    margin-top: 33px;
    width: 200px;
    height: 56px;
    background: #ff9820;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    z-index: 1;
    cursor: pointer;
    transition: background-color 0.5s;
  }
  .btn:hover {
    background: #f18200;
  }
}

@media all and (max-width: 768px) {
  .main {
    height: 200px;
    .bg-img {
      width: 241px;
      height: 186px;
    }
    .tit {
      font-size: 18px;
    }
    .des {
      margin-top: 15px;
      font-size: 14px;
    }
    .btn {
      margin-top: 20px;
      width: 120px;
      height: 46px;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MakeAppointment.vue